import type { ReactNode } from "react";

interface Props {
  variant?: "default" | "depth" | "object" | "closed";
  icon?: ReactNode;
  children: ReactNode;
  title?: string;
}

/** Design `Badge`: 28px capsule for one short fact. Closed badges always carry an icon. */
export function Badge({ variant = "default", icon, children, title }: Props) {
  const cls = variant === "default" ? "ds-badge" : `ds-badge ds-badge--${variant}`;
  return (
    <span className={cls} title={title}>
      {icon}
      {children}
    </span>
  );
}
